import { DepartmentType } from '../models';

export const DEPARTMENT_TYPES: DepartmentType[] = [
    {
        'id': 1,
        'name': 'Bravo Regular',
        'code': 'BR',
    },
    {
        'id': 2,
        'name': 'Aeropuerto SJ',
        'code': 'AT1',
    },
    {
        'id': 3,
        'name': 'Aeropuerto Liberia',
        'code': 'AT2',
    },
    {
        'id': 4,
        'name': 'Back Up',
        'code': 'BK',
    },
    {
        'id': 5,
        'name': 'Unidad preventiva',
        'code': 'UP',
    },
    {
        'id': 6,
        'name': 'Servicio especial',
        'code': 'SP',
    },
    {
        'id': 7,
        'name': 'Unidad canina',
        'code': 'UK',
    },
    {
        'id': 8,
        'name': 'Custodios',
        'code': 'CU',
    },
    {
        'id': 9,
        'name': 'Supervisores',
        'code': 'OP',
    },
    {
        'id': 10,
        'name': 'Administrativos',
        'code': 'AD',
    },
    {
        'id': 11,
        'name': 'Central',
        'code': 'CT',
    },
    {
        'id': 12,
        'name': 'Operaciones Monitoreo',
        'code': 'OM',
    },
];

export enum DepartmentTypeEnum {
    BR = 1,
    AT1 = 2,
    AT2 = 3,
    BK = 4,
    UP = 5,
    SP = 6,
    UK = 7,
    CU = 8,
    OP = 9,
    AD = 10,
    CT = 11,
    OM = 12,
}
